var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height"},[_c('v-card',{staticClass:"rounded-lg fill-height",attrs:{"width":"100%","height":"100%"}},[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.bulletin.url,"width":"100%","height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }